import { cn } from '@/lib/cn';
import { Breadcrumbs } from './breadcrumbs/Breadcrumbs';
import { UsersList } from './UsersList';
import ShakeFeature from '../shakeApp/ShakeFeature';

interface SubheaderProps {
  currentItem: Record<string, unknown> | undefined;
  location: { pathname: string };
  shakeAccess: boolean;
  user: Record<string, unknown> | null;
}

const Subheader = ({ currentItem, location, shakeAccess, user }: SubheaderProps) => {
  const isInProject = (currentItem as Record<string, unknown>)?.itemtype === 'project';
  const userRole = (user as Record<string, { S: string }>)?.role?.S;
  const displayShake = isInProject && shakeAccess && userRole !== 'viewer';

  return (
    <div
      className={cn(
        'sticky top-14 z-40 flex items-center border-b border-border/60 bg-card/80 px-4 backdrop-blur-xl',
        isInProject ? 'h-12 justify-between' : 'h-10',
      )}
    >
      <Breadcrumbs currentItem={currentItem} location={location} />
      {isInProject && (
        <div className="flex items-center gap-1">
          {displayShake && (
            <ShakeFeature projectId={(currentItem as Record<string, unknown>)?.projectId} />
          )}
          <UsersList />
        </div>
      )}
    </div>
  );
};

export default Subheader;
